import React from "react";
import ModalSafeArea from "./ModalSafeArea";
import { useTranslation } from "react-i18next";

const ExpressCheckoutModal = ({ open, onClose, onGo, backdropOpacity = 0.45, style }) => {
    const { t } = useTranslation();

    return (
        <ModalSafeArea open={open} onClose={onClose} backdropOpacity={backdropOpacity} style={style}>
            <div className="relative bg-white rounded-md shadow-2xl p-6 text-center">
                <button
                    aria-label="Close"
                    style={{ right: "1rem" }}
                    className="absolute top-2 text-2xl text-gray-900"
                    onClick={onClose}
                >
                    <i className="icon icon-close"></i>
                </button>
                <h2 className=" text-2xl  mb-3 mt-6">{t("express-check-out")}</h2>
                <p className="text-gray-900 mb-2">{t("it-looks-like-your-stay-is-coming-to-an-end")}</p>
                <p className="text-gray-900 mb-6">{t("you-can-easily-complete-your-check-out-in-just-a-few-steps")}</p>
                <button className="w-full py-2 rounded btn-accent text-base font-bold" onClick={onGo}>
                    {t("go-to-check-out")}
                </button>
            </div>
        </ModalSafeArea>
    );
};

export default ExpressCheckoutModal;
